import React, { useEffect, useRef, useState } from 'react'
import axios from 'axios'
import * as faceapi from 'face-api.js'

import { getMasterIdentity, stopMaster } from './services/webrtc/master'
import {
  VEYETALS_API_BASE_URL,
  // VEYETALS_API_START,
  VEYETALS_API_START_DEEP,
  VEYETALS_API_KEY,
  VEYETALS_API_CREATE_CHANNEL
} from './config/VeyetalsAPI'
import { formValuesMaster, CognitoIdentityPoolCA } from './config/formValues'
import formattedDate from './utils/formattedDate'

import VeyetalsCards from './components/VeyetalsCards/VeyetalsCards'
import VideoControls from './components/VideoControls/VideoControls'
import ProgressBar from './components/ProgressBar/ProgressBar'
import FaceTracker from './components/FaceTracker/FaceTracker'
import Message from './components/Message/Message'
import Modal from './components/Modal/Modal'
import Button from './components/Button/Button'

import './VeyetalsView.scss'

export default function VeyetalsView({
  userId,
  channelId,
  onComplete = (results) => {},
  showUI = true,
  modelPath = process.env.PUBLIC_URL + '/models'
}) {
  const instance = axios.create({
    baseURL: VEYETALS_API_BASE_URL,
    headers: {
      post: {
        'x-api-key': VEYETALS_API_KEY
      }
    }
  })

  const channelName = `${userId}-${channelId}`

  const localVideoRef = useRef()

  const [isModelLoaded, setIsModelLoaded] = React.useState(false)

  const [showButtons, setShowButtons] = useState(false)
  const [isFirstScan, setIsFirsatScan] = useState(true)

  const [progress, setProgress] = useState(0)

  const [errorMessage, setErrorMessage] = useState('')
  const [messageType, setMessageType] = useState('')
  const [showMessage, setShowMessage] = useState(true)

  const [timer, setTimer] = useState(10)
  const [showTimer, setShowTimer] = useState(false)

  const [showVeyetalsButton, setShowVeyetalsButton] = useState(false)

  const [showRetry, setShowRetry] = useState(true)

  const [veyetalsResults, setveyetalsResults] = useState({
    hr: -1,
    hrv: -1,
    o2: -1,
    // resp: -1,
    systolic: -1,
    diastolic: -1,
    stress: -2,
    glucose: -1,
    isValidHeartRate: false,
    isValidBloodPressure: false,
    snr: -1,
    gender: '',
    age_low: 0,
    age_high: 0,
    emotion: ''
  })

  const [facePosition, setFacePosition] = useState({
    right: 0,
    top: 0,
    width: '0px',
    height: '0px',
    previewColor: '#19be87'
  })

  const [openModal, setOpenModal] = useState(false)

  const handleOpenModal = () => setOpenModal(true)
  const handleCloseModal = () => setOpenModal(false)

  useEffect(() => {
    setShowButtons(true)
    setIsFirsatScan(true)
    startMasterUserVideo()
    setShowVeyetalsButton(false)
    setShowRetry(true)

    loadModels()
  }, [])

  useEffect(() => {
    if (progress === 100) {
      handleOpenModal()
    }
  }, [progress])

  const onStatsReport = (report) => {
    // TODO: Publish stats
  }

  useEffect(() => {
    localVideoRef.current.onloadedmetadata = () => {
      // Once the metadata is loaded, we can get the video dimensions
      const videoWidth = localVideoRef.current.videoWidth
      const videoHeight = localVideoRef.current.videoHeight
      console.log('Video width: ', videoWidth)
      console.log('Video height: ', videoHeight)

      // Get frame rate from the video stream track settings
      const videoTrack = localVideoRef.current.srcObject.getVideoTracks()[0]
      const frameRate = videoTrack.getSettings().frameRate
      console.log('Frame rate: ', frameRate)
    }
  }, [localVideoRef?.current?.srcObject])

  const resetVeyetals = () => {
    setveyetalsResults({
      hr: -1,
      hrv: -1,
      o2: -1,
      resp: -1,
      systolic: -1,
      diastolic: -1,
      stress: -2,
      glucose: -1,
      isValidHeartRate: false,
      isValidBloodPressure: false,
      snr: -1,
      gender: '',
      ageLow: 0,
      ageHigh: 0,
      emotion: ''
    })
    window.sessionStorage.setItem('isVeyetalsStarted', false)
    handleCloseModal()
    setShowRetry(true)
    setProgress(0)
  }

  const updateVeyetals = (vitals, statusCode) => {
    return {
      hr: Math.round(vitals.HR),
      hrv: Math.round(vitals.HRV),
      o2: Math.round(vitals.SpO2),
      resp: Math.round(vitals.RR),
      systolic: Math.round(vitals.systolic),
      diastolic: Math.round(vitals.diastolic),
      stress: Math.round(vitals.stress),
      glucose: Math.round(vitals.glucose),
      isValidHeartRate: true,
      isValidBloodPressure: true,
      snr: vitals.snr,
      gender: vitals.gender,
      ageLow: vitals.age_low,
      ageHigh: vitals.age_high,
      emotion: vitals.emotion
    }
  }

  const loadModels = async () => {
    console.log(`Model URL: ${modelPath}`)

    Promise.all([faceapi.nets.ssdMobilenetv1.loadFromUri(modelPath)]).then(
      setIsModelLoaded(true)
    )
  }

  const updateFaceTracker = (detections, videoRef) => {
    if (!videoRef) return

    // const isVeyetalsStarted = JSON.parse(
    //   window.sessionStorage.getItem('isVeyetalsStarted')
    // )

    if (detections.length === 0 || detections.length > 1) {
      const errorMessage =
        detections.length === 0 ? 'No face detected' : 'Too many users'

      // showError(errorMessage)
      window.sessionStorage.setItem('isErrorState', true)
      window.sessionStorage.setItem('errorMessage', errorMessage)

      return
    } else {
      window.sessionStorage.setItem('isErrorState', false)
    }

    const clientWidth = videoRef?.current?.clientWidth || 1
    const clientHeight = videoRef?.current?.clientHeight || 1
    const videoWidth = videoRef?.current?.videoWidth || 1
    const videoHeight = videoRef?.current?.videoHeight || 1

    const box = detections[0].box
    let [x, y, width, height] = [box.x, box.y, box.width, box.height]

    const widthFactor = clientWidth / videoWidth
    const heightFactor = clientHeight / videoHeight

    ;[x, y, width, height] = [
      x * widthFactor,
      y * heightFactor,
      width * widthFactor,
      height * heightFactor
    ]

    const faceArea = width * height

    const screenArea =
      clientWidth > clientHeight
        ? clientHeight * clientHeight
        : clientWidth * clientWidth

    setFacePosition({
      right: Math.ceil(x),
      top: Math.ceil(y),
      width: `${Math.ceil(width)}px`,
      height: `${Math.ceil(height)}px`,
      previewColor: faceArea >= 0.15 * screenArea ? '#19be87' : '#ff0000'
    })

    if (faceArea < 0.15 * screenArea) {
      // showError('Sorry, user is too far')
      window.sessionStorage.setItem('isErrorState', true)
      window.sessionStorage.setItem('errorMessage', 'User is too far')
    } else {
      window.sessionStorage.setItem('isErrorState', false)
    }
  }

  const onMasterDataMessage = async (event) => {
    const isErrorState = JSON.parse(
      window.sessionStorage.getItem('isErrorState')
    )

    console.log(`Remote Message: ${event.data}, Error State: ${isErrorState}`)

    if (event.data) {
      try {
        const json = JSON.parse(event.data)
        if (json.status === 'success') {
          if (json.statusCode === 1 || json.statusCode === 2) {
            setMessageType('scanning')
            setveyetalsResults(
              updateVeyetals(json.responseData.vitals, json.statusCode)
            )

            setProgress((prev) =>
              json.responseData.vitals.progress > prev
                ? json.responseData.vitals.progress
                : prev
            )
          }
          if (json.statusCode === 2) {
            setMessageType('complete')

            setShowButtons(true)
            window.sessionStorage.setItem('isVeyetalsStarted', false)
            const results = updateVeyetals(
              json.responseData.vitals,
              json.statusCode
            )
            results.isValidHeartRate = validateHeartRate(results.hr)
            results.isValidBloodPressure = validateBP(
              results.systolic,
              results.diastolic
            )

            setShowRetry(false)

            setveyetalsResults(results)

            setProgress(100)
          }
        } else {
          const error =
            json.message !== undefined
              ? json.message
              : 'An unknown error occurred. Please try again'
          showError(error)
        }
      } catch (err) {
        console.log(`Failed to parse server message ${err}`)
      }
    }
  }

  // const onTimeUpdateLocal = () => {
  //   const ref = localVideoRef.current
  //   if (
  //     ref &&
  //     !!(ref.currentTime > 0 && !ref.paused && !ref.ended && ref.readyState > 2)
  //   ) {
  //     setLocalVideoActive(true)
  //   }
  // }

  const createChannel = async (channelName) => {
    try {
      const response = await instance.post(VEYETALS_API_CREATE_CHANNEL, {
        channelName
      })
      console.log(response)
    } catch (error) {
      console.log(error)
    }
  }

  const startMasterUserVideo = () => {
    setMessageType('loading')
    resetVeyetals()

    const cognitoIdentityPool = CognitoIdentityPoolCA

    createChannel(channelName).then(() => {
      getMasterIdentity(
        localVideoRef.current,
        { ...formValuesMaster, channelName },
        cognitoIdentityPool.region,
        cognitoIdentityPool.identityPoolId,
        cognitoIdentityPool.roleArn,
        onStatsReport,
        onMasterDataMessage
      ).catch((err) => {
        console.log(err)
      })
    })
  }

  const startVeyetals = async () => {
    resetVeyetals()
    setMessageType('start')
    setTimer(10)
    setShowTimer(false)
    window.sessionStorage.setItem('isVeyetalsStarted', true)
    try {
      const response = await instance.post(VEYETALS_API_START_DEEP, {
        userId,
        channelId,
        channelName,
        recordId: `${channelName}-${formattedDate()}`
      })
      window.sessionStorage.setItem(
        'taskARN',
        response.data.responseData.taskARN
      )
      console.log(response)
    } catch (error) {
      console.log(error)
    }
  }

  const startTimer = (seconds, onTimerComplete) => {
    return new Promise((resolve) => {
      const interval = setInterval(() => {
        setTimer((prevTime) => prevTime - 1)
      }, 1000)

      setTimeout(() => {
        clearInterval(interval)
        onTimerComplete()
        resolve()
      }, seconds * 1000)
    })
  }

  const handleStartVeyetals = () => {
    setShowMessage(false)
    const isErrorState = JSON.parse(
      window.sessionStorage.getItem('isErrorState')
    )
    if (!isErrorState) {
      if (isFirstScan) setIsFirsatScan(false)
      setShowTimer(true)
      setShowButtons(false)
      startTimer(10, startVeyetals)
    } else {
      showError(window.sessionStorage.getItem('errorMessage'))
      setShowMessage(true)
    }
  }

  const validateHeartRate = (hr) => hr > 0 && hr < 480

  const validateBP = (sys, dia) =>
    sys > 40 && sys < 250 && dia > 30 && dia < 150

  const handleVideoOnPlay = async () => {
    setMessageType('loadingFaceTracking')

    if (!isModelLoaded) {
      console.log('Model is not loaded')
      return
    }

    let detections = await faceapi.detectAllFaces(
      localVideoRef.current,
      new faceapi.SsdMobilenetv1Options()
    )

    if (detections) {
      setMessageType('doneLoadingFaceTracking')
      setShowVeyetalsButton(true)
    }

    const refreshId = setInterval(async () => {
      if (!localVideoRef.current) {
        clearInterval(refreshId)
      }

      if (localVideoRef.current) {
        detections = await faceapi.detectAllFaces(
          localVideoRef.current,
          new faceapi.SsdMobilenetv1Options()
        )
        updateFaceTracker(detections, localVideoRef)
      }
    }, 300)
  }

  const handleOnComplete = () => {
    stopMaster()
    handleCloseModal()
    onComplete(veyetalsResults)
  }

  const showError = (error) => {
    setMessageType('error')
    setErrorMessage(error)
    setShowButtons(true)
  }

  const renderCards = () =>
    showUI ? (
      <VeyetalsCards result={veyetalsResults} progress={progress} />
    ) : (
      <ProgressBar progress={progress} />
    )

  return (
    <div className='veyetals-view'>
      <Modal isOpen={openModal}>
        <div className='veyetals-view__modal'>
          <span>Click "OK" to complete the scan</span>
          <div className='veyetals-view__modal-button'>
            <Button color='primary' text='OK' onClick={handleOnComplete} />
          </div>
        </div>
      </Modal>

      <div className='veyetals-view__video-container'>
        <video
          ref={localVideoRef}
          className='veyetals-view__video'
          autoPlay
          playsInline
          onPlay={handleVideoOnPlay}
        />
        <FaceTracker
          top={facePosition.top}
          right={facePosition.right}
          width={facePosition.width}
          height={facePosition.height}
          color={facePosition.previewColor}
          showTimer={showTimer}
          count={timer}
        />
      </div>

      <div className='veyetals-view__container'>
        <Message
          errorMessage={errorMessage}
          type={messageType}
          showMessage={showMessage}
          setShowMessage={setShowMessage}
        />
        <VideoControls
          isFirstScan={isFirstScan}
          showButtons={showButtons}
          showRetry={showRetry}
          showVeyetalsButton={showVeyetalsButton}
          startVeyetals={handleStartVeyetals}
        />
        {renderCards()}
      </div>
    </div>
  )
}
